import API, { ensurePrefixed } from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import getFormattedValues, { formatReceived, hasFiles } from 'utils/formatValues';
import { padronesEnum } from 'views/Tramites/GPM/enums';
import { postGenerarCargos } from '.';

export const baseURI = 'recaudacion/conceptos-de-infracciones/';
const files = ['archivo_cancelacion'];
const headers = { 'Content-Type': 'multipart/form-data' };
/**
 * GET Concepto de Infraccion
 * @param {Object} params
 * @returns {Promise<Array<object>>}
 */
export const getConceptosDeInfracciones = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Concepto de Infraccion
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getConceptosDeInfraccion = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Concepto de Infraccion
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postConceptosDeInfraccion = async (_values, match, accion = 'CONCEPTOS_DE_INFRACCION') => {
  try {
    const values = { ..._values };
    const accionInf = ensurePrefixed('CREAR_', accion);
    if (match.tipo_de_cargo) {
      const valuesCargo = {
        padron: 19,
        padron_id: values.infraccion,
        idPadron: padronesEnum.INFRACCIONES,
        importe: values.importe,
        tipo_de_cargo: match.tipo_de_cargo,
        descripcion: match.descripcion_corta,
      };
      const [[cargo]] = await postGenerarCargos(valuesCargo);
      if (!cargo) return false;
      values.cargo = cargo.id;
    }
    const response = await API.post(baseURI, values, {
      accionInf,
      idPadron: padronesEnum.INFRACCIONES,
      clave: values.clave,
    });
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Concepto de Infraccion
 * @param {number} id
 * @param {object} _values
 * @returns {Promise<object|boolean>}
 */
export const patchConceptoDeInfracciones = async (id, _values, accion = 'CONCEPTOS_DE_INFRACCION') => {
  try {
    const config = hasFiles(_values, files) ? { headers } : {};
    const accionInf = ensurePrefixed('ACTUALIZAR_', accion);
    const formattedValues = getFormattedValues(_values, {
      formData: config.headers,
      files,
      clean: false,
    });
    const response = await API.patch(`${baseURI}${id}`, formattedValues, {
      ...config,
      accionInf,
      idPadron: padronesEnum.INFRACCIONES,
      clave: formattedValues.clave,
    });
    onSuccess(response, 'Editado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};
/**
 * DELETE Concepto de Infraccion
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteConceptoDeInfraccion = async ({ infraccionId, conceptos, accion = 'CONCEPTOS_DE_INFRACCION' }) => {
  try {
    const _conceptos = Array.isArray(conceptos) ? conceptos : [conceptos];
    const accionInf = ensurePrefixed('CANCELAR_', accion);
    const response = await API.post(`/recaudacion/infracciones/${infraccionId}/cancelar_conceptos/`, {
      conceptos_a_cancelar: _conceptos,
    }, { accionInf, idPadron: padronesEnum.INFRACCIONES });
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
